import React, {useEffect, useState} from "react";
import styled from "styled-components";
import Img from "gatsby-image";
import useInterval from "../../hooks/useInterval";
import {graphql, useStaticQuery} from "gatsby";

const NavigationContainer = styled.div`
  position: absolute;
  bottom: 15px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const NavigationHandler = styled.span`
  background-color: #ffffff;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  opacity: 0.7;
  margin: 0 5px;
  cursor: pointer;
`;

const ActiveNavigationHandler = styled(NavigationHandler)`
  opacity: 0.5;
`;

const swipeEffect = (setIndex, index, slides) => {
  let touchSurface = document.getElementById('touchSurface'),
    startX,
    startY,
    distRight,
    distLeft,
    threshold = 100, //required min distance traveled to be considered swipe
    allowedTime = 500, // maximum time allowed to travel that distance
    startTime;

  const handleTouchStart = (e) => {
    const touchObj = e.changedTouches[0];
    distRight = 0
    startX = touchObj.pageX
    startY = touchObj.pageY
    startTime = new Date().getTime() // record time when finger first makes contact with surface
    e.preventDefault()
  }

  const isSwipeRight = (touchObj) => (new Date().getTime() - startTime) <= allowedTime && distRight >= threshold && Math.abs(touchObj.pageY - startY) <= 100;
  const isSwipeLeft = (touchObj) => (new Date().getTime() - startTime) <= allowedTime && distLeft >= threshold && Math.abs(touchObj.pageY - startY) <= 100;


  const handleTouchMove = (e) => e.preventDefault(); // prevent scrolling when inside DIV

  const handleTouchEnd = (e) => {
    const touchObj = e.changedTouches[0];
    distRight = touchObj.pageX - startX;
    distLeft = startX - touchObj.pageX;

    isSwipeLeft(touchObj) && setIndex(index === slides.length - 1 ? 0 : index + 1);
    isSwipeRight(touchObj) && setIndex(index === 0 ? slides.length - 1 : index - 1);

    e.preventDefault();
  }

  touchSurface.addEventListener('touchstart', handleTouchStart, false)
  touchSurface.addEventListener('touchmove', handleTouchMove, false)
  touchSurface.addEventListener('touchend', handleTouchEnd, false);

  return () => {
    touchSurface.removeEventListener("touchstart", handleTouchStart);
    touchSurface.removeEventListener("touchmove", handleTouchMove);
    touchSurface.removeEventListener("touchend", handleTouchEnd);
  };
}

const Slider = () => {
  const images = useStaticQuery(graphql`
        query {
          conferinte: file(relativePath: { eq: "slides/conferinte.jpg" }) {
            childImageSharp {
              fluid(maxWidth: 2000, quality: 100) {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          },
          workshopuri: file(relativePath: { eq: "slides/workshopuri.jpg" }) {
            childImageSharp {
              fluid(maxWidth: 2000, quality: 100) {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          },
          concursuri: file(relativePath: { eq: "slides/concursuri.jpg" }) {
            childImageSharp {
              fluid(maxWidth: 2000, quality: 100) {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          },
          expo: file(relativePath: { eq: "slides/expo.jpg" }) {
            childImageSharp {
              fluid(maxWidth: 2000, quality: 100) {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          },
          targ: file(relativePath: { eq: "slides/targ.jpg" }) {
            childImageSharp {
              fluid(maxWidth: 2000, quality: 100) {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          },
          emisiune: file(relativePath: { eq: "slides/emisiune.jpg" }) {
            childImageSharp {
              fluid(maxWidth: 2000, quality: 100) {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          }
        }`
  );

  const slides = [
    images.conferinte,
    images.workshopuri,
    images.concursuri,
    images.expo,
    images.targ,
    images.emisiune,
  ];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    return swipeEffect(setIndex, index, slides);
  }, [index, slides]);

  useInterval(
    () => {
      setIndex( index === (slides.length - 1) ? 0 : index + 1);
    },
    10000);

  return (
    <div
      css={`
        width: 100%;
        height: 100%;
        position: relative;
      `}
    >
      <div id="touchSurface">
        <Img
          fluid={slides[index].childImageSharp.fluid}
          key={slides[index].name}
          alt={slides[index].name}
        />
      </div>

      <NavigationContainer>
        {slides.map((slide, i) => (
          i === index
            ? <ActiveNavigationHandler key={i} />
            : <NavigationHandler key={i} onClick={() => setIndex(i)} />)
        )}
      </NavigationContainer>
    </div>
  )
};

export default Slider;